import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "message-input-mute"
};
var _hoisted_2 = ["contenteditable"];
import { toRefs, ref, onMounted, watch, onUnmounted } from '../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { Editor } from '@tiptap/core';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import Mention from '@tiptap/extension-mention';
import CustomImage from './message-input-file';
import MessageInputAtSuggestion from './message-input-at/index';
import { isH5, isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-input-editor',
  props: {
    placeholder: {
      type: String,
      default: 'this is placeholder'
    },
    replayOrReferenceMessage: {
      type: Object,
      default: () => ({})
    },
    isMuted: {
      type: Boolean,
      default: true
    },
    muteText: {
      type: String,
      default: ''
    },
    enableInput: {
      type: Boolean,
      default: true
    },
    enableAt: {
      type: Boolean,
      default: true
    },
    enableDragUpload: {
      type: Boolean,
      default: true
    },
    enableTyping: {
      type: Boolean,
      default: true
    }
  },
  emits: ['sendMessage', 'onTyping', 'onAt'],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var {
      placeholder,
      enableAt,
      enableDragUpload,
      enableTyping
    } = toRefs(props);
    var inputContentEmpty = ref(true);
    var inputBlur = ref(true);
    var isC2C = ref(false);
    var allInsertedAtInfo = new Map();
    var editorDom = ref();
    var editor = null;
    function onCurrentConversationUpdated(conversation) {
      isC2C.value = (conversation === null || conversation === void 0 ? void 0 : conversation.type) === TUIChatEngine.TYPES.CONV_C2C;
    }
    onMounted(() => {
      editor = isPC ? new Editor({
        element: editorDom.value,
        extensions: [Document, Paragraph, Text, Placeholder.configure({
          emptyEditorClass: 'is-editor-empty',
          placeholder: placeholder.value
        }), Mention.configure({
          HTMLAttributes: {
            class: 'mention'
          },
          suggestion: enableAt.value && MessageInputAtSuggestion()
        }), CustomImage.configure({
          inline: true,
          allowBase64: true,
          HTMLAttributes: {
            class: 'custom-image'
          }
        })],
        autofocus: !isH5,
        editable: true,
        injectCSS: false,
        // handle input edtor typing (only in C2C and enable typing)
        onUpdate(_ref2) {
          var _transaction$doc;
          var {
            editor,
            transaction
          } = _ref2;
          if (!enableTyping.value || !isC2C.value) return;
          inputBlur.value = !editor.isFocused;
          if ((transaction === null || transaction === void 0 || (_transaction$doc = transaction.doc) === null || _transaction$doc === void 0 || (_transaction$doc = _transaction$doc.content) === null || _transaction$doc === void 0 ? void 0 : _transaction$doc.size) > 2) {
            inputContentEmpty.value = false;
          } else {
            inputContentEmpty.value = true;
          }
        },
        onFocus() {
          var _document;
          if (isH5 && (_document = document) !== null && _document !== void 0 && (_document = _document.getElementById('app')) !== null && _document !== void 0 && _document.style) {
            // set app height when keyboard popup
            var keyboardHeight = document.body.scrollHeight - window.innerHeight;
            document.getElementById('app').style.marginBottom = "".concat(keyboardHeight, "px");
            document.getElementById('app').style.height = "calc(100% - ".concat(keyboardHeight, "px)");
          }
          if (!enableTyping.value || !isC2C.value) return;
          inputBlur.value = true;
        },
        onBlur() {
          var _document2;
          if (isH5 && (_document2 = document) !== null && _document2 !== void 0 && (_document2 = _document2.getElementById('app')) !== null && _document2 !== void 0 && _document2.style) {
            // reset app height to normal
            document.getElementById('app').style.marginBottom = '';
            document.getElementById('app').style.height = '100%';
          }
          if (!enableTyping.value || !isC2C.value) return;
          inputBlur.value = true;
        }
      }) : null;
      TUIStore.watch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
    });
    var handleEnter = e => {
      if (isH5) {
        return;
      }
      e === null || e === void 0 || e.preventDefault();
      e === null || e === void 0 || e.stopPropagation();
      if (e.keyCode === 13 && e.ctrlKey) {
        var _editor;
        // ctrl + enter: warp
        (_editor = editor) === null || _editor === void 0 || (_editor = _editor.commands) === null || _editor === void 0 || _editor.insertContent('<p></p>');
      } else if (e.keyCode === 13) {
        // enter only: send message
        emits('sendMessage');
      }
    };
    var handleH5Input = e => {
      if (isH5) {
        var _editorDom$value;
        e.data === '@' && emits('onAt', true);
        inputContentEmpty.value = !((_editorDom$value = editorDom.value) !== null && _editorDom$value !== void 0 && _editorDom$value.childNodes);
      }
    };
    var handleH5Blur = () => {
      isH5 && (inputBlur.value = true);
    };
    var handleH5Focus = () => {
      isH5 && (inputBlur.value = false);
    };
    var insertAt = atInfo => {
      var _editorDom$value2;
      if (!allInsertedAtInfo.has(atInfo.id)) {
        allInsertedAtInfo.set(atInfo.id, atInfo.label);
      }
      var mentionText = document.createElement('span');
      mentionText.innerHTML = atInfo.label;
      mentionText.className = 'mention';
      (_editorDom$value2 = editorDom.value) === null || _editorDom$value2 === void 0 || _editorDom$value2.appendChild(mentionText);
    };
    // fileMap 存储 fileURL 与 fileObject 的映射
    var fileMap = new Map();
    var handleFileDrop = e => {
      // pc 端 支持富文本拖拽上传
      // 移动端 不支持
      e.preventDefault();
      e.stopPropagation();
      if (isPC) {
        handleFileDropOrPaste(e, 'drop');
      }
    };
    var handleFilePaste = e => {
      // pc 端 屏蔽原生复制，支持富文本复制，走富文本复制上传解析
      // 移动端，仅支持文本复制，走默认复制解析
      if (isPC) {
        // pc 端 支持富文本复制，走富文本复制上传解析
        e.preventDefault();
        e.stopPropagation();
        handleFileDropOrPaste(e, 'paste');
      }
    };
    var handleFileDropOrPaste = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (e, type) {
        if (!(enableDragUpload !== null && enableDragUpload !== void 0 && enableDragUpload.value) && type === 'drop') {
          return;
        }
        if (type === 'drop' && e.dataTransfer || type === 'paste' && e.clipboardData) {
          var _e$dataTransfer, _e$clipboardData;
          var files = type === 'drop' ? e === null || e === void 0 || (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : _e$dataTransfer.files : e === null || e === void 0 || (_e$clipboardData = e.clipboardData) === null || _e$clipboardData === void 0 ? void 0 : _e$clipboardData.files;
          for (var i = 0; i < files.length; i++) {
            var _editor2;
            var file = files[i];
            var isImage = file.type.startsWith('image/');
            var fileSrc = isImage ? URL.createObjectURL(file) : yield drawFileCanvasToImageUrl(file);
            (_editor2 = editor) === null || _editor2 === void 0 || (_editor2 = _editor2.commands) === null || _editor2 === void 0 || _editor2.insertContent({
              type: 'custom-image',
              attrs: {
                src: fileSrc,
                alt: file === null || file === void 0 ? void 0 : file.name,
                title: file === null || file === void 0 ? void 0 : file.name,
                class: isImage ? 'normal' : 'file'
              }
            });
            fileMap.set(fileSrc, file);
            if (i === files.length - 1) {
              setTimeout(() => {
                var _editor3, _editor4;
                (_editor3 = editor) === null || _editor3 === void 0 || (_editor3 = _editor3.commands) === null || _editor3 === void 0 || _editor3.focus('end');
                (_editor4 = editor) === null || _editor4 === void 0 || (_editor4 = _editor4.commands) === null || _editor4 === void 0 || _editor4.scrollIntoView();
              }, 10);
            }
          }
        }
      });
      return function handleFileDropOrPaste(_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    // create file icon image
    // 为了避免重复创建拥有相同icon图标的img dom，将之前已有类型进行记录
    // 记录格式为 map<icon type，img dom>
    var fileIconDomMap = new Map();
    var addImageProcess = (src, type) => {
      return new Promise((resolve, reject) => {
        if (fileIconDomMap.has(type)) {
          resolve(fileIconDomMap.get(type));
        } else {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            fileIconDomMap.set(type, img);
            resolve(img);
          };
          img.onerror = reject;
          img.src = src;
        }
      });
    };
    // draw file tag canvas
    var drawFileCanvasToImageUrl = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (file) {
        var {
          name,
          type
        } = file;
        var canvas = document.createElement('canvas');
        var width = 160;
        var height = 50;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        // 设置内存中的实际大小（缩放以考虑额外的像素密度）
        var scale = window.devicePixelRatio; // 在视网膜屏幕上更改为 1 以查看模糊
        canvas.width = Math.floor(width * scale);
        canvas.height = Math.floor(height * scale);
        var ctx = canvas.getContext('2d');
        if (!ctx) {
          return '';
        }
        // 标准化坐标系以使用 css 像素
        ctx.scale(scale, scale);
        // draw icon
        var {
          iconSrc,
          iconType
        } = handleFileIconForShow(type);
        var img = yield addImageProcess(iconSrc, iconType);
        ctx === null || ctx === void 0 || ctx.drawImage(img, 10, 10, 30, 30);
        // draw font
        var nameForShow = handleNameForShow(name);
        ctx.fillText(nameForShow, 45, 22);
        // canvas to url
        var dataURL = canvas.toDataURL();
        return dataURL;
      });
      return function drawFileCanvasToImageUrl(_x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleFileIconForShow = type => {
      var urlBase = 'https://web.sdk.qcloud.com/component/TUIKit/assets/file-';
      var fileTypes = ['image', 'pdf', 'text', 'ppt', 'presentation', 'sheet', 'zip', 'word', 'video', 'unknown'];
      var url = '';
      var iconType = '';
      fileTypes.forEach(typeName => {
        if (type.includes(typeName)) {
          url = urlBase + typeName + '.svg';
          iconType = typeName;
        }
      });
      return {
        iconSrc: url || urlBase + 'unknown.svg',
        iconType: iconType || 'unknown'
      };
    };
    // 获取字符串的实际占位长度（字母or符号:1，其他（主要是中文):）
    var handleNameForShow = value => {
      if (!value) {
        return value;
      }
      var res = '';
      var length = 0;
      for (var i = 0; i < (value === null || value === void 0 ? void 0 : value.length); i++) {
        if (length > 16) {
          res += '...';
          break;
        }
        res += value[i];
        if (/[a-z]|[0-9]|[,;.!@#-+/\\$%^*()<>?:"'{}~]/i.test(value[i])) {
          length += 1;
        } else {
          length += 2;
        }
      }
      return res;
    };
    var getEditorContent = () => {
      return isPC ? parsePCEditorContent() : parseH5EditorContent();
    };
    function parsePCEditorContent() {
      var _editor5, _content, _content2;
      var editorJSON = (_editor5 = editor) === null || _editor5 === void 0 ? void 0 : _editor5.getJSON();
      var content = [];
      handleEditorContent(editorJSON, content);
      if (content.length > 0 && content[content.length - 1] && ((_content = content[content.length - 1]) === null || _content === void 0 ? void 0 : _content.type) === 'text' && (_content2 = content[content.length - 1]) !== null && _content2 !== void 0 && (_content2 = _content2.payload) !== null && _content2 !== void 0 && (_content2 = _content2.text) !== null && _content2 !== void 0 && _content2.endsWith('\n')) {
        var text = content[content.length - 1].payload.text;
        content[content.length - 1].payload.text = text === null || text === void 0 ? void 0 : text.substring(0, text.lastIndexOf('\n'));
      }
      return content;
    }
    function handleEditorContent(root, content) {
      if (!root || !root.type) {
        return;
      }
      if (root.type !== 'text' && root.type !== 'custom-image' && root.type !== 'mention') {
        var _root$content;
        if (root.type === 'paragraph') {
          handleEditorNode(root, content);
        }
        if ((_root$content = root.content) !== null && _root$content !== void 0 && _root$content.length) {
          root.content.forEach(item => {
            handleEditorContent(item, content);
          });
        }
      } else {
        handleEditorNode(root, content);
      }
    }
    function handleEditorNode(node, content) {
      var _node$attrs, _node$attrs3, _node$attrs5;
      // handle enter
      if (node.type === 'paragraph') {
        var _content3;
        if (content.length > 0 && content[content.length - 1] && ((_content3 = content[content.length - 1]) === null || _content3 === void 0 ? void 0 : _content3.type) === 'text') {
          content[content.length - 1].payload.text += '\n';
        }
      } else if (node.type === 'text' || node.type === 'custom-image' && (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.class) === 'emoji') {
        var _node$attrs2, _content4;
        // 处理 text 和 emoji
        var text = node.type === 'text' ? node === null || node === void 0 ? void 0 : node.text : node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.alt;
        if (content.length > 0 && content[content.length - 1] && ((_content4 = content[content.length - 1]) === null || _content4 === void 0 ? void 0 : _content4.type) === 'text') {
          content[content.length - 1].payload.text += text;
        } else {
          content.push({
            type: 'text',
            payload: {
              text: text
            }
          });
        }
      } else if (node.type === 'custom-image' && (node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.class) === 'normal') {
        var _node$attrs4;
        // 处理富文本图像
        content.push({
          type: 'image',
          payload: {
            file: fileMap === null || fileMap === void 0 ? void 0 : fileMap.get(node === null || node === void 0 || (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.src)
          }
        });
      } else if (node.type === 'custom-image' && (node === null || node === void 0 || (_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.class) === 'file') {
        var _node$attrs6, _file$type;
        var file = fileMap === null || fileMap === void 0 ? void 0 : fileMap.get(node === null || node === void 0 || (_node$attrs6 = node.attrs) === null || _node$attrs6 === void 0 ? void 0 : _node$attrs6.src);
        content.push({
          type: file !== null && file !== void 0 && (_file$type = file.type) !== null && _file$type !== void 0 && _file$type.includes('video') ? 'video' : 'file',
          payload: {
            file
          }
        });
      } else if (node.type === 'mention') {
        var _node$attrs7, _content5, _content6;
        var _text = '@' + (node === null || node === void 0 || (_node$attrs7 = node.attrs) === null || _node$attrs7 === void 0 ? void 0 : _node$attrs7.label) + ' ';
        if (content.length > 0 && content[content.length - 1] && ((_content5 = content[content.length - 1]) === null || _content5 === void 0 ? void 0 : _content5.type) === 'text') {
          content[content.length - 1].payload.text += _text;
        } else {
          content.push({
            type: 'text',
            payload: {
              text: _text
            }
          });
        }
        if ((_content6 = content[content.length - 1]) !== null && _content6 !== void 0 && (_content6 = _content6.payload) !== null && _content6 !== void 0 && _content6.atUserList) {
          var _content7, _node$attrs8;
          (_content7 = content[content.length - 1]) === null || _content7 === void 0 || (_content7 = _content7.payload) === null || _content7 === void 0 || (_content7 = _content7.atUserList) === null || _content7 === void 0 || _content7.push(node === null || node === void 0 || (_node$attrs8 = node.attrs) === null || _node$attrs8 === void 0 ? void 0 : _node$attrs8.id);
        } else {
          var _node$attrs9;
          content[content.length - 1].payload.atUserList = [node === null || node === void 0 || (_node$attrs9 = node.attrs) === null || _node$attrs9 === void 0 ? void 0 : _node$attrs9.id];
        }
      }
    }
    function parseH5EditorContent() {
      var root = editorDom.value;
      var text = '';
      var atUserList = [];
      try {
        for (var child of root.childNodes) {
          var _child$classList, _child$classList2;
          if (child.nodeName === '#text' || child.nodeName === 'SPAN' || (_child$classList = child.classList) !== null && _child$classList !== void 0 && _child$classList.contains('custom-image-emoji') || (_child$classList2 = child.classList) !== null && _child$classList2 !== void 0 && _child$classList2.contains('mention')) {
            text += child.nodeValue || child.alt || child.innerHTML;
          }
        }
      } catch (error) {
        if (error instanceof Error) {
          throw error;
        }
      }
      allInsertedAtInfo === null || allInsertedAtInfo === void 0 || allInsertedAtInfo.forEach((value, key) => {
        if (text.includes('@' + value)) {
          atUserList.push(key);
        }
      });
      return [{
        type: 'text',
        payload: {
          text,
          atUserList
        }
      }];
    }
    var addEmoji = emojiData => {
      if (isPC) {
        var _editor6;
        (_editor6 = editor) === null || _editor6 === void 0 || (_editor6 = _editor6.commands) === null || _editor6 === void 0 || _editor6.insertContent({
          type: 'custom-image',
          attrs: {
            src: emojiData === null || emojiData === void 0 ? void 0 : emojiData.url,
            alt: emojiData === null || emojiData === void 0 ? void 0 : emojiData.emoji.key,
            title: emojiData === null || emojiData === void 0 ? void 0 : emojiData.emoji.key,
            class: 'emoji'
          }
        });
      } else {
        var _editorDom$value3;
        var emojiImgNode = document.createElement('img');
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('src', emojiData === null || emojiData === void 0 ? void 0 : emojiData.url);
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('class', 'custom-image custom-image-emoji');
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('alt', emojiData === null || emojiData === void 0 ? void 0 : emojiData.emoji.key);
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('title', emojiData === null || emojiData === void 0 ? void 0 : emojiData.emoji.key);
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('width', '20px');
        emojiImgNode === null || emojiImgNode === void 0 || emojiImgNode.setAttribute('height', '20px');
        (_editorDom$value3 = editorDom.value) === null || _editorDom$value3 === void 0 || _editorDom$value3.appendChild(emojiImgNode);
      }
      if (!isH5) {
        var _editor7, _editor8;
        (_editor7 = editor) === null || _editor7 === void 0 || (_editor7 = _editor7.commands) === null || _editor7 === void 0 || _editor7.focus();
        (_editor8 = editor) === null || _editor8 === void 0 || (_editor8 = _editor8.commands) === null || _editor8 === void 0 || _editor8.scrollIntoView();
      } else {
        var _editorDom$value4;
        (_editorDom$value4 = editorDom.value) === null || _editorDom$value4 === void 0 || _editorDom$value4.focus();
        placeCaretAtEnd(editorDom.value);
      }
    };
    function placeCaretAtEnd(el) {
      var _document$body;
      el.focus();
      if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel === null || sel === void 0 || sel.removeAllRanges();
        sel === null || sel === void 0 || sel.addRange(range);
      } else if (typeof ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.createTextRange) !== 'undefined') {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
    }
    var blur = () => {
      var _editor9, _editorDom$value5;
      isPC ? (_editor9 = editor) === null || _editor9 === void 0 || (_editor9 = _editor9.commands) === null || _editor9 === void 0 ? void 0 : _editor9.blur() : (_editorDom$value5 = editorDom.value) === null || _editorDom$value5 === void 0 ? void 0 : _editorDom$value5.blur();
    };
    var resetEditor = () => {
      var _editor10;
      (_editor10 = editor) === null || _editor10 === void 0 || (_editor10 = _editor10.commands) === null || _editor10 === void 0 || _editor10.clearContent(true);
      fileMap === null || fileMap === void 0 || fileMap.clear();
      inputBlur.value = true;
      inputContentEmpty.value = true;
      if (!isH5) {
        var _editor11;
        (_editor11 = editor) === null || _editor11 === void 0 || (_editor11 = _editor11.commands) === null || _editor11 === void 0 || _editor11.focus();
      } else {
        allInsertedAtInfo === null || allInsertedAtInfo === void 0 || allInsertedAtInfo.clear();
        editorDom.value.innerHTML = '';
      }
    };
    var setEditorContent = content => {
      var _editor12;
      (_editor12 = editor) === null || _editor12 === void 0 || (_editor12 = _editor12.commands) === null || _editor12 === void 0 || _editor12.insertContent(content);
    };
    watch(() => [inputContentEmpty.value, inputBlur.value], (newVal, oldVal) => {
      if (newVal !== oldVal) {
        emits('onTyping', inputContentEmpty.value, inputBlur.value);
      }
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      getEditorContent,
      addEmoji,
      resetEditor,
      insertAt,
      setEditorContent,
      blur
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['message-input-editor-container', _unref(isH5) && 'message-input-editor-container-h5'])
      }, [__props.isMuted ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.muteText), 1)) : _createCommentVNode("", true), !__props.isMuted && __props.enableInput ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        ref_key: "editorDom",
        ref: editorDom,
        class: "message-input-editor-area",
        contenteditable: _unref(isH5),
        onKeydown: _withKeys(handleEnter, ["enter"]),
        onDrop: handleFileDrop,
        onPaste: handleFilePaste,
        onInput: handleH5Input,
        onBlur: handleH5Blur,
        onFocus: handleH5Focus
      }, null, 40, _hoisted_2)) : _createCommentVNode("", true)], 2);
    };
  }
});